module.exports = __webpack_public_path__ + "static/media/cny_4.a7172ec3.jpg";